import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AbstractCrudComponent } from '../../component/abstract-crud.component';
import { ConfirmationDialogComponent } from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { FilialService } from '../filial.service';

@Component({
  selector: 'app-filial-list',
  templateUrl: './filial-list.component.html',
  styleUrls: ['./filial-list.component.css']
})
export class FilialListComponent extends AbstractCrudComponent {

  displayedColumns: string[] = ['nome', 'cnpj', 'fone', 'details'];

  constructor(private filialService: FilialService, router: Router, dialog: MatDialog) {

    super(router, dialog);
  }

  ngOnInit() {
    this.reloadData();

    super.ngOnInit();
  }

  reloadData() {
    this.filialService.listarComProjecao()
      .subscribe(data => {
        // console.log(data)
        this.data = data;
        this.configurarDataSource();
      }, error => {
        console.log(error);
      });
  }

  confirmDelete(id: number) {
    const confirmDialog = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Confirmação de exclusão',
        message: 'Deseja realmente remover essa informação ?'
      }
    });
    confirmDialog.afterClosed().subscribe(result => {
      if (result === true) {
        this.delete(id);
      }
    });
  }

  delete(id: number) {
    this.filialService.remover(id)
      .subscribe(
        data => {
          // console.log(data);
          this.reloadData();
        },
        error => {
          console.log(error);
        });
  }

  add() {
    this.router.navigate(['manterFilial']);
  }

  details(id: number) {
    this.router.navigate(['manterFilial'], {
      state: {
        id: id,
        isUpdate: 'N'
      }
    });
  }

  update(id: number) {
    this.router.navigate(['manterFilial'], {
      state: {
        id: id,
        isUpdate: 'S'
      }
    });
  }

}
